export default function (theme: 'light' | 'dark' = 'light') {
  document.body.setAttribute('arco-theme', theme)
}
